import Const from './const';
const DATA = Const.DATA

function isLocalStorageUsable() {
    const localStorageTestKey = '__localStorage_support_test';
    const localStorageTestValue = 'test';
    let isSupport = false;

    try {
        localStorage.setItem(localStorageTestKey, localStorageTestValue);
        if (localStorage.getItem(localStorageTestKey) === localStorageTestValue) {
            isSupport = true;
        }
        localStorage.removeItem(localStorageTestKey);
        return isSupport;
    } catch (e) {
        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
            console.warn('localStorage 存储已达上限！');
        } else {
            console.warn('当前浏览器不支持 localStorage！');
        }
        return isSupport;
    }
}

function normalizeKey(key) {
    if (typeof key !== 'string') {
        console.warn(`${key} used as a key, but it is not a string.`);
        key = String(key);
    }
    return key;
}

function serialize(value, callback) {
    try {
        const valueString = JSON.stringify(value);
        callback(null, valueString);
    } catch (e) {
        callback(e);
    }
}
class StorageHandler {
    ready() {
        if (this.isSupport == null) {
            this.isSupport = isLocalStorageUsable();
        }
        return this.isSupport
    }

    setItem(key, value) {
        key = normalizeKey(key);
        if (this.ready()) {
            if (value === undefined) {
                value = null;
            }
            serialize(value, (error, valueString) => {
                if (error) { return; }
                try {
                    // 可能会因超出最大存储空间，存储失败。
                    const FINAL_KEY = `${DATA.KEY_PREFIX}${key}`;
                    localStorage.setItem(FINAL_KEY, valueString);
                } catch (e) {
                    console.log('e', e);
                }
            });
        }
    }
    getItem(key) {
        key = normalizeKey(key);
        const FINAL_KEY = `${DATA.KEY_PREFIX}${key}`;
        return JSON.parse(localStorage.getItem(FINAL_KEY));
    }

    setToken(value) {
        this.setItem(DATA.KEY_TOKEN, value);
    }
    getToken() {
        return this.getItem(DATA.KEY_TOKEN)
    }

    setUser(value) {
        this.setItem(DATA.KEY_USER, value);
    }
    getUser() {
        return this.getItem(DATA.KEY_USER)
    }

    setUserType(value) {
        this.setItem(DATA.KEY_USER_TYPE, value);
    }
    getUserType() {
        return this.getItem(DATA.KEY_USER_TYPE)
    }

    setLoginType(value) {
        this.setItem(DATA.KEY_LOGIN_TYPE, value);
    }
    getLoginType() {
        return this.getItem(DATA.KEY_LOGIN_TYPE)
    }

    setAuthority(value) {
        this.setItem(DATA.KEY_AUTHORITY_LIST, value);
    }
    getAuthority() {
        return this.getItem(DATA.KEY_AUTHORITY_LIST)
    }

    setOrderField(value) {
        this.setItem(DATA.KEY_ORDER_FIELD, value);
    }
    getOrderField() {
        return this.getItem(DATA.KEY_ORDER_FIELD)
    }

    setStationField(value) {
        this.setItem(DATA.KEY_STATION_FIELD, value);
    }
    getStationField() {
        return this.getItem(DATA.KEY_STATION_FIELD)
    }

    setOrderListHint(value) {
        this.setItem(DATA.KEY_ORDER_LIST_HINT, value);
    }
    getOrderListHint() {
        return this.getItem(DATA.KEY_ORDER_LIST_HINT)
    }
    setUserOrderListHint(value) {
        this.setItem(DATA.KEY_USER_ORDER_LIST_HINT, value);
    }
    getUserOrderListHint() {
        return this.getItem(DATA.KEY_USER_ORDER_LIST_HINT)
    }

    setOperatorCustom(value) {
        this.setItem(DATA.KEY_OPERATOR_CUSTOM, value);
    }
    getOperatorCustom() {
        return this.getItem(DATA.KEY_OPERATOR_CUSTOM)
    }

    setWxPlatforminfo(value) {
        this.setItem(DATA.KEY_WX_PLATFORM_INFO, value);
    }
    getWxPlatforminfo() {
        return this.getItem(DATA.KEY_WX_PLATFORM_INFO)
    }

    setTokenExpirTime(value) {
        this.setItem(DATA.KEY_TOKEN_EXPIR_TIME, value);
    }
    getTokenExpirTime() {
        return this.getItem(DATA.KEY_TOKEN_EXPIR_TIME)
    }


    setServiceChargeTipFlag(value) {
        // 1 已读 / 0 未读
        this.setItem(DATA.KEY_SERVICE_CHARGE_TIP_FLAG, value);
    }
    getServiceChargeTipFlag() {
        return this.getItem(DATA.KEY_SERVICE_CHARGE_TIP_FLAG);
    }

    /** 设置本次 场地险弹窗弹出时间 (毫秒时间戳) */
    setInsuranceTipTime(value) {
        this.setItem(DATA.KEY_INSURANCE_TIP_FLAG, value);
    }
    getInsuranceTipTime() {
        return this.getItem(DATA.KEY_INSURANCE_TIP_FLAG) || 0;
    }


    setServiceVersion(value) {
        this.setItem(DATA.KEY_SERVICE_CHARGE_VERSION, value ? true : false);
    }
    getServiceVersion() {
        const value = this.getItem(DATA.KEY_SERVICE_CHARGE_VERSION)
        if (value === null || value === undefined) {
            return true
        }
        return value;
    }
}

export default new StorageHandler();
